export const DaviviendaDepositBanks = [
    { value: '000001', label: 'BANCO DE BOGOTÁ' },
    { value: '000002', label: 'BANCO POPULAR' },
    { value: '000006', label: 'ITAÚ CORPBANCA COLOMBIA S.A.' },
    { value: '000007', label: 'BANCOLOMBIA S.A.' },
    { value: '000009', label: 'CITIBANK COLOMBIA' },
    { value: '000012', label: 'GNB SUDAMERIS S.A.' },
    { value: '000013', label: 'BBVA COLOMBIA' },
    { value: '000019', label: 'COLPATRIA' },
    { value: '000023', label: 'BANCO DE OCCIDENTE' },
    { value: '000032', label: 'BANCO CAJA SOCIAL - BCSC S.A.' },
    { value: '000040', label: 'BANCO AGRARIO DE COLOMBIA S.A.' },
    { value: '000051', label: 'BANCO DAVIVIENDA S.A.' },
    { value: '000052', label: 'BANCO AV VILLAS' },
    { value: '000053', label: 'BANCO W S.A.' },
    { value: '000058', label: 'BANCO CREDIFINANCIERA S.A.C.F' },
    { value: '000059', label: 'BANCAMIA' },
    { value: '000060', label: 'BANCO PICHINCHA S.A.' },
    { value: '000061', label: 'BANCOOMEVA' },
    { value: '000062', label: 'CMR FALABELLA S.A.' },
    { value: '000063', label: 'BANCO FINANDINA S.A.' },
    { value: '000065', label: 'BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A.' },
    { value: '000066', label: 'BANCO COOPERATIVO COOPCENTRAL' },
    { value: '000067', label: 'BANCO COMPARTIR S.A' },
    { value: '000069', label: 'BANCO SERFINANZA S.A' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
export const daviviendabankDocumentTypes = [
    { value: '01', label: 'NIT' },
    { value: '02', label: 'Citizenship Card' },
    { value: '03', label: 'Identity Card' },
    { value: '04', label: 'Alien Card' },
    { value: '05', label: 'Passport' },
    { value: '06', label: 'Social Security Card' },
    { value: '07', label: 'Nit Under' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
export const daviviendabankAccountTypes = [
    { value: 'CC', label: 'Current account' },
    { value: 'CA', label: 'Savings account' },
    { value: 'TP', label: 'Prepaid card' },
    { value: 'DP', label: 'Daviplata' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
